import * as React from "react"

const LoadBuilder = (props) => (
  <svg
    width={24}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m15.714.5-.001 7.857h3.93v7.857H22v3.143h-3.143v-1.571h-6.286v1.571H9.43v-1.571H3.143v1.571H0v-3.143h2.357V8.357h3.927L6.286.5h9.428Zm-1.571 9.429h-2.357v6.285h6.285V9.93h-2.357V11.5h-1.571V9.929Zm-7.857 0H3.929v6.285h6.285V9.93H7.857V11.5H6.286V9.929Zm3.928-7.858H7.857v6.286h6.286V2.071h-2.357v1.572h-1.572V2.07Z"
      fill="#80B8EE"
    />
  </svg>
)

export default LoadBuilder